<template>
  <div>
    <b-input-group class="mt-1 mb-3">
      <b-form-input v-model="address.name" placeholder="Adresa" class="w-50"/>
      <b-form-input v-model="address.bloc" placeholder="Bloc"/>
      <b-form-input v-model="address.scara" placeholder="Scara"/>
      <b-form-input v-model="address.reper" placeholder="Reper"/>
    </b-input-group>
    <b-card no-body>
      <l-map
        ref="map"
        :center="companyLocation"
        :zoom="15"
        style="width: 100%; height: 500px"
      >
        <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <l-marker
          :lat-lng="markerPosition"
          :draggable="true"
          @dragend="onMarkerDragEnd"
        />
      </l-map>
      <div class="map-datas" v-if="coordinatesSelected && markerPosition">
        <p>
          Latitudine: <strong>{{ markerPosition.lat }}</strong>
        </p>
        <p>
          Longitudine: <strong>{{ markerPosition.lng }}</strong>
        </p>
        <b-btn class="mt-3" variant="success" block @click="save">Salvează adresa</b-btn>
      </div>
    </b-card>
  </div>
</template>

<script>
import { uuid } from 'uuidv4'
import config from '@/config'
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'

// Fix default marker icon paths
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41], // точка иконки, которая соответствует позиции маркера (нижний кончик)
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})

export default {
  name: 'ManualAddress',
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  props: {
    address: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      markerPosition: null,
      coordinatesSelected: false
    }
  },
  computed: {
    companyLocation () {
      const location = this.$store.getters['auth/companyLocation']
      return { lat: location.lat, lng: location.lng }
    }
  },
  mounted () {
    this.markerPosition = this.companyLocation
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.map && this.$refs.map.mapObject) {
          this.$refs.map.mapObject.invalidateSize()
        }
      }, 100)
    })
  },
  methods: {
    onMarkerDragEnd (event) {
      const latLng = event.target.getLatLng()
      console.log(latLng)
      this.markerPosition = {
        lat: latLng.lat,
        lng: latLng.lng
      }
      this.coordinatesSelected = true
    },
    save () {
      const newAddress = {
        place_id: uuid().toString(),
        name: this.address.name,
        scara: this.address.scara,
        bloc: this.address.bloc,
        reper: this.address.reper,
        comment: this.address.comment,
        lat: this.markerPosition.lat,
        lng: this.markerPosition.lng
      }
      console.log(newAddress)

      this.$axios.post(config.addrApiUrl + '/add-place', newAddress)
        .then((response) => {
          this.$toasted.success('Adresa salvată', {
            duration: 3000
          })
          this.$emit('address-saved', newAddress)
        })
        .catch((error) => {
          error.response.data.errors.forEach(e => {
            this.$toasted.error(e.msg + ' for field &nbsp; <b>' + e.path + '</b>', {
              duration: 3000
            })
          })
        })
    }
  }
}
</script>

<style scoped>
.map-datas {
  position: relative;
  z-index: 1000;
  background: white;
  padding: 15px;
  margin-top: -127px;
  width: 270px;
}
</style>
